import Blue from '~/core';

new Blue({
  name: 'Header Nav Menu',
  selector: '.header',
  setup(header) {
    const headerUtil = header.querySelector('.header__util');
    const searchToggle = header.querySelector('.nav-menu__search');
    const searchRow = header.querySelector('.header__search');
    const toggleEvents = 'click.prevent enter.prevent space.prevent';

    if (this.$screen.lg_dn.matches) {
      if (headerUtil) headerUtil.classList.add('is-hidden');
      header.classList.add('is-stickied');
    } else {
      if (!headerUtil) header.classList.add('is-stickied');
    }

    const handleHeaderDisplay = () => {
      if (headerUtil) {
        if (
          window.scrollY > headerUtil.offsetHeight ||
          this.$screen.lg_dn.matches
        ) {
          headerUtil.classList.add('is-hidden');
          header.classList.add('is-stickied');
        } else {
          headerUtil.classList.remove('is-hidden');
          header.classList.remove('is-stickied');
        }
      } else {
        header.classList.add('is-stickied');
      }
    };

    const toggleSearch = () => {
      searchToggle.classList.toggle('is-active');
      searchRow.classList.toggle('is-active');
    };

    window.addEventListener('scroll', handleHeaderDisplay);

    if (searchRow) {
      this.$addEvents(searchToggle, toggleEvents, toggleSearch);
    }
  },
});

new Blue({
  name: 'Header Nav Mobile',
  selector: '.header',
  setup(header) {
    const drawer = header.querySelector('.header__drawer');
    const drawerInner = drawer.querySelector('.drawer__inner');
    const navItems = [...header.querySelectorAll('.nav__primary > .nav__item')];
    const navUtilItems = [
      ...header.querySelectorAll('.nav__util > .nav-util__link'),
    ];
    const utilItems = [...header.querySelectorAll('.util__link')];
    const drawerToggle = header.querySelector('.nav-menu__toggle');
    const searchRow = header.querySelector('.header__search');
    const toggleEvents = 'click.prevent enter.prevent space.prevent';

    const toggleDrawer = () => {
      drawer.classList.toggle('is-active');
      drawerToggle.classList.toggle('is-active');
      document.body.classList.toggle('scroll-lock');
    };

    this.$addEvents(drawerToggle, toggleEvents, toggleDrawer);

    if (searchRow) {
      this.$retach(searchRow, {
        destination: drawerInner,
        mediaQuery: this.$screen.lg_dn,
        movedClass: 'drawer__search',
      });
    }
    navItems.forEach(i => {
      this.$retach(i, {
        destination: drawerInner,
        mediaQuery: this.$screen.lg_dn,
        movedClass: 'drawer__item',
      });
    });
    utilItems.forEach(i => {
      this.$retach(i, {
        destination: drawerInner,
        mediaQuery: this.$screen.lg_dn,
        movedClass: 'drawer__link',
      });
    });
    navUtilItems.forEach(i => {
      this.$retach(i, {
        destination: drawerInner,
        mediaQuery: this.$screen.lg_dn,
        movedClass: 'drawer__button',
      });
    });
    // utilItems.forEach(i => {
    //  this.$retach(i, {
    //    destination: drawerInner,
    //    mediaQuery: this.$screen.lg_dn,
    //    movedClass: 'in-drawer',
    //    wrapper: 'li',
    //    wrapperClass: 'drawer__item',
    //  });
    // });

    const menuItems = navItems.filter(
      i => !!i.querySelector('.nav__secondary')
    );
    const relations = [];

    const toggleMenu = item => {
      if (this.$screen.lg.matches) return;
      item.toggle();
    };

    menuItems.forEach(container => {
      const trigger = container.querySelector('.nav__toggle .nav__icon');
      const content = container.querySelector('.nav__secondary');
      const config = {
        container,
        trigger,
        content,
        relations,
        externalEvents: true,
        props: ['height', 'opacity'],
      };
      const toggle = new this.$toggle(config);
      relations.push(toggle);
      this.$addEvents(trigger, 'click.prevent', () => toggleMenu(toggle));
    });
  },
});
